import { omitBy } from 'lodash-es';
import type { CoreTypes } from '../../core';
import type { Room } from '../types/rooms';

export default (locations: Room[]): CoreTypes.MixedWithoutInternalId.Location[] => {
  if (!Array.isArray(locations))
    throw new Error('(SS12000::From::Room) Room input is not of array type', { cause: 'invalid_input' });

  return locations
    .map((location): CoreTypes.MixedWithoutInternalId.Location => ({
      ids: location.id,
      ...omitBy({
        displayName: location.displayName,
        seats:       location.seats,
        tags:        location.tags,
      }, x => x == null),
    }));
};